export default __webpack_public_path__ + "static/mast-44576ecee017afeef29e6b124b2292ff.jpg";